import { customAxios, IDUSUARIO, ENTREGAS_URL } from '../constants';
import {
  LISTA_PROGRAMADAS, PROGRAMAR_PLANIFICACION, REPROGRAMAR_PLANIFICACION,
  REPROGRAMAR_ADPER, PROGRACION_CALENDAR, DIAS_TRASLADO
} from './types';
import { evalAction, serverError } from '../utils/actionError';

export function programarPlanificacion(object, verpersona, varusuario, Rows, Programadafecha, numHorEntr) {
  let valFilial = object.codFilial;
  let observacion ="";

  if (object.codLugEntrega === '2') {
    valFilial = '000';
  }

  if(object.obsContacto !== undefined ){
    if( object.obsContacto !== null){
      if(object.obsContacto.length > 0){
        observacion = object.obsContacto.replace(/\n/g, "<br />");
      }
    }
  }



  const data = {
    codFilial: valFilial,
    codLugEntrega: object.codLugEntrega,
    codTransp: object.codTransp,
    codUsuResp: object.codUsuResp,
    dirContacto: object.dirContacto,
    emaContacto: object.emaContacto,
    emaContConfi: object.emaContConfi,
    fecProgramada: Programadafecha,
    invitacionCal: object.codEntrega,
    nomContacto: object.nomContacto,
    obsContacto: observacion,
    personalAd: verpersona,
    telContacto: object.telContacto,
    tipPlaca: object.tipPlaca,
    numFichaVtaVeh: Rows.numFichaVta,
    numPedidoVeh: Rows.numPedidoVeh,
    nurFichaVtaPedido: Rows.nurFichaVtaPedido,
    codProv: Rows.codProv,
    codCia: Rows.codCia,
    numHorEntr,
    tipoCorreo: '0',

  };
  const config = {
    headers: {
      idUsuario: IDUSUARIO,
    },
  };

  const request = customAxios.post(`${ENTREGAS_URL}/entrega-vehiculo/planificaciones/`, data, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: PROGRAMAR_PLANIFICACION,
    payload: request,
  };
}

export function reProgramarPlanificacion(object, verpersona, varusuario, Rows, Programadafecha, numHorEntr,tipoReprogramacion) {
  let valFilial = object.codFilial;
  let observacion = "";

  if(object.obsContacto !== undefined ){
    if( object.obsContacto !== null){
      if(object.obsContacto.length > 0){
        observacion = object.obsContacto.replace(/\n/g, "<br />");
      }
    }
  }

  if (object.codLugEntrega === '2') {
    valFilial = '000';
  }





  const data = {
    codPlanEntrVehi: object.codPlanEntrVehi,
    codFilial: valFilial,
    codLugEntrega: object.codLugEntrega,
    codTransp: object.codTransp,
    codUsuResp: object.codUsuResp,
    dirContacto: object.dirContacto,
    emaContacto: object.emaContacto,
    emaContConfi: object.emaContConfi,
    fecProgramada: Programadafecha,
    invitacionCal: object.codEntrega,
    nomContacto: object.nomContacto,
    obsContacto: observacion,
    personalAd: verpersona,
    telContacto: object.telContacto,
    tipPlaca: object.tipPlaca,
    numFichaVtaVeh: Rows.numFichaVta,
    numPedidoVeh: Rows.numPedidoVeh,
    nurFichaVtaPedido: Rows.nurFichaVtaPedido,
    codProv: Rows.codProv,
    codCia: Rows.codCia,
    numHorEntr,
    tipoCorreo: '1',
    tipoReprogramacion: tipoReprogramacion,

  };

  const config = {
    headers: {
      idUsuario: IDUSUARIO,
    },
  };

  const request = customAxios.post(`${ENTREGAS_URL}/entrega-vehiculo/planificaciones/${object.codLugEntrega}/reprogramaciones`, data, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: REPROGRAMAR_PLANIFICACION,
    payload: request,
  };
}

export function personasAdicionales(idProgramacion) {
  const config = {
    params: {
      codigo: idProgramacion,
    },
  };

  const request = customAxios.get(`${ENTREGAS_URL}/entrega-vehiculo/planificaciones/${idProgramacion}/personal`, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: REPROGRAMAR_ADPER,
    payload: request,
  };
}

export function programacionCalendario(codFilialEntr, codFilialDisp, codFamiliaVehDisp, indFlota, indTipoCapa) {
  const config = {
    params: {
      codFilialEntr,
      codFilialDisp,
      codFamiliaVehDisp,
      indFlota,
      indTipoCapa,
    },
    headers: {
      idUsuario: IDUSUARIO,
    },
  };
  // lugares de entrega
  const request = customAxios.get(`${ENTREGAS_URL}/entrega-vehiculo-maestro/lugares-entrega-despacho`, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: PROGRACION_CALENDAR,
    payload: request,
  };
}
// implementar lugar de despacho


export function dias_traslado(numPedidoVeh, codCia, codProv, codSucuDest) {
  const config = {
    params: {
      numPedidoVeh,
      codCia,
      codProv,
      codSucuDest,
    },
    headers: {
      idUsuario: IDUSUARIO,
    },
  };


  const request = customAxios.get(`${ENTREGAS_URL}/entrega-vehiculo-maestro/dias-traslado`, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: DIAS_TRASLADO,
    payload: request,
  };
}
export function listarProgramacionXsede(tipoProg, lugarEntrega, fecProIni, fecProFin, familia) {
  const config = {
    params: {
      tipoProg,
      numPedido: '',
      numChasis: '',
      numFichaVta: '',
      numProforma: '',
      codAreaVta: '',
      zonaCom: '',
      codFilial: '',
      fecComIni: '',
      fecComFin: '',
      fecLogIni: '',
      fecLogFin: '',
      fecProIni,
      fecProFin,
      fecRecepIni: '',
      fecRecepFin: '',
      cia: '',
      asesorCom: '',
      codMarca: '',
      baumauster: '',
      codCliente: '',
      familia,
      estadoPedido: '',
      estadoPlan: '',
      estadoCan: '',
      transp: '',
      tipoPlaca: '',
      lugarEntrega,


    },
    headers: {
      idUsuario: IDUSUARIO,
      indPaginado: 'N',
      nroPag: '1',
      cantidadxPag: '1',

    },
  };
  const request = customAxios.get(`${ENTREGAS_URL}/entrega-vehiculo/planificaciones`, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))
  
  return {
    type: LISTA_PROGRAMADAS,
    payload: request,
  };
}



// WEBPACK FOOTER //
// ./src/actions/PlanificacionPedido.js